"use client";
'use strict';

var cookies = require('js-cookie');
var React = require('react');
var cookieWatcher = require('@sravni/utils/lib/cookieWatcher');

function useCookieWatcher(cookieName, opts) {
    const [value, setValue] = React.useState(() => cookies.get(cookieName));
    const [watcher] = React.useState(() => new cookieWatcher.CookieWatcher(opts));
    const onCookieChange = React.useCallback((cookie) => {
        if (!cookie)
            return;
        setValue(cookie.value);
    }, []);
    React.useEffect(() => {
        watcher.addChangeListener(cookieName, onCookieChange);
        return () => watcher?.destroy();
    }, [watcher, onCookieChange, cookieName]);
    return [value];
}

exports.useCookieWatcher = useCookieWatcher;
//# sourceMappingURL=useCookieWatcher.js.map
